<div class="box box-sombra-content box-inclui">
    <div class="box-inclui">
        <h3 class="title-h3">{{'O que inclui' | translate}}:</h3>
        <ul>
            <li *ngFor="let i of incluso">
                <div class="icon">
                    <i class="material-icons">done</i>
                </div>
                <span>{{i.descricao}}</span>
            </li>
        </ul>  
    </div>
    <div class="box-nao-inclui nao-inclui">
        <h3 class="title-h3">{{'O que não inclui' | translate}}:</h3> 
        <ul>
            <li *ngFor="let i of naoIncluso">
                <div class="icon">
                    <i class="material-icons">clear</i>
                </div>
                <span>{{i.descricao}}</span>
            </li>
        </ul>
    </div> 
</div> 